import { ChargeWaiverSearchCriteria } from "domain/entity/ChargeWaiver/ChargeWaiverSearchCriteria";
import { ChargeWaiverConstant } from "presentation/constant/ChargeWaiver/ChargeWaiverConstant";
import { useChargeWaiverVM } from "presentation/hook/ChargeWaiver/useChargeWaiverVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useChargeWaiverTracked } from "presentation/store/ChargeWaiver/ChargeWaiverProvider";
import { useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import ChargeWaiverSearchForm from "./ChargeWaiverSearchForm";

const ChargeWaiverSearchPanel = () => {
    const CHARGE_WAIVER_CONSTANT = ChargeWaiverConstant.Search;
    const [chargeWaiverState] = useChargeWaiverTracked();
    const chargeWaiverVM = useChargeWaiverVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();


    const resetButtonClicked = useCallback(() => {
        chargeWaiverVM.onSearchCriteriaResetClick();
    }, [chargeWaiverVM]);

    const searchButtonClicked = useCallback((criteria: ChargeWaiverSearchCriteria) => {
        if (!criteria.shippingBill && (!criteria.cntrList || (criteria.cntrList && criteria.cntrList.length === 0))) {
            messageBarVM.showError("Shipping Bill / Bill of Lading or Container No. must input search criteria first.");
            return;
        }
        setIsLoading(true);
        chargeWaiverVM.setIsSearchLoading(true);
        chargeWaiverVM.searchChargeWaiverData(criteria).then((data) => {
            setIsLoading(false);
            chargeWaiverVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            chargeWaiverVM.setIsSearchLoading(false);
        })

    }, [chargeWaiverVM, messageBarVM])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{CHARGE_WAIVER_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={chargeWaiverVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        {/* Stack Form Start */}
                        <ChargeWaiverSearchForm />
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked(chargeWaiverState.searchCriteria)} />
            </SidebarActionBar>
        </div>
    );
}

export default ChargeWaiverSearchPanel;
